module.exports = __webpack_public_path__ + "6d2b0f10a00c2e0f6c1878bc43c4b5dc.jpg";